"use client";

import * as React from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { Map } from "lucide-react";
import TrailMap from "@/components/article-shell/TrailMap";
import { MobileBottomToolRegistration } from "@/components/mobile-bottom-tools";
import { getTrailMapLabel, TRAIL_QUERY_PARAM } from "@/lib/article-trail";

interface ArticleMobileMapToolProps {
  enabled: boolean;
}

export default function ArticleMobileMapTool({
  enabled,
}: ArticleMobileMapToolProps) {
  return (
    <React.Suspense
      fallback={
        <ArticleMobileMapToolContent
          enabled={enabled}
          requestedTrailCategory={null}
        />
      }
    >
      <ArticleMobileMapToolWithSearchParams enabled={enabled} />
    </React.Suspense>
  );
}

function ArticleMobileMapToolWithSearchParams({
  enabled,
}: ArticleMobileMapToolProps) {
  const searchParams = useSearchParams();
  return (
    <ArticleMobileMapToolContent
      enabled={enabled}
      requestedTrailCategory={searchParams.get(TRAIL_QUERY_PARAM)}
    />
  );
}

function ArticleMobileMapToolContent({
  enabled,
  requestedTrailCategory,
}: ArticleMobileMapToolProps & {
  requestedTrailCategory: string | null;
}) {
  const pathname = usePathname() ?? "";
  const mapTitle = getTrailMapLabel(pathname, requestedTrailCategory);

  if (!enabled) return null;

  return (
    <MobileBottomToolRegistration
      tool={{
        id: "map",
        kind: "panel",
        label: "지도",
        icon: Map,
        order: 0,
        ariaLabel: `${mapTitle} 열기`,
        sheet: {
          title: mapTitle,
          resizable: true,
          defaultHeightRatio: 0.5,
          minHeightRatio: 0.3,
          maxHeightRatio: 0.85,
          content: (
            <div className="flex h-full min-h-0 flex-col">
              <TrailMap />
            </div>
          ),
        },
      }}
    />
  );
}
